import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccountBoxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"account_box"}/>
}
